export type PackageStatusColor = 'default' | 'success' | 'warning';

export const PACKAGE_TABS = ['Details', 'Package inclusions', 'Inventory mapping', 'Package regions'] as const;
export const DEFAULT_PACKAGE_TAB = PACKAGE_TABS[0];

export type PackageTab = (typeof PACKAGE_TABS)[number];

export interface OfferBuilderPackage {
  name: string;
  package: App.Package;
  packageSummary: string;
  sortableId: string;
  sortOrder?: number;
  statusColor: PackageStatusColor;
  statusLabel: string;
}
